export const ChannelMap: Record<string, string> = {
    hunting: 'Hunting',
    'farming-1': 'Farming 1',
    'farming-2': 'Farming 2',
    selfservice: 'Autosserviço',
    digital: 'Digital',
    platform: 'Platform',
}
